<div class="t-popup popup-patientDetails" cdkDrag>

    <div class="t-popup-close"></div>
    
    <div class="t-popup-frame" style="display: flex; flex-direction:column;" >
        <div *ngIf="page!=='Patients'" style="display: flex; width: 50%; float: right" >
            
            <button class="search-btn " style="background-color: #6d7cab00;">Select Patient</button>
            <img class="w10" src="assets/images/arr-right.svg"/>
            <button class="search-btn " style="background-color: #6d7cab00;color: #277382;font-weight: 900;" >Patient Details</button>
            <img class="w10" src="assets/images/arr-right.svg"/>
            <button class="search-btn" style="background-color: #6d7cab00;" >Appointment</button>
        </div>
        <button class="t-btn-popup-close" aria-label="close popup" (click)="close(false)"></button>
        <div class="t-popup-body">


            <h2 cdkDragHandle style="cursor: pointer;">
                Patient Details Form
            </h2>
            <!-- box (end) -->

            <div class="l-flex l-flex-w t-fieldmargin patient-details">
                
                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <div class="t-field l-flex t-twin-fieldset">
                            <label style='width: 3em'>
                                <input checked type="radio" name="id" [(ngModel)]="myPat.IsID" [value]="1" class="custom-check customInput" aria-labelledby="pregnancy_popup-anomales" >
                                <i class="customInput-display"></i>
                                <span>
                                    ID
                                </span>
                            </label>
                            <label style='width: 4em'>
                                <input type="radio" name="id" [(ngModel)]="myPat.IsID" [value]="0" class="custom-check customInput" aria-labelledby="pregnancy_popup-anomales">
                                <i class="customInput-display"></i>
                                <span>
                                    Pass
                                </span>
                            </label>
                        </div>

                        <i class="t-sep"></i>

                        <div class="t-validation-wrap">
                            <input type="text" [(ngModel)]="myPat.ID" class="t-field-text w100" (keyup)="clearSpace()" [attr.type]="myPat.IsID == 1 ? 'number' : 'text'" [ngClass]="IDValidator() && ! iderr? '': 'is-invalid'" (change)="idchanged=true"/>
                            <div class="t-validation-message">
                                <span>{{iderr? iderr : 'Invalid ID Number'}}</span>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            First Name
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.First" class="t-field-text w100" (change)="idchanged=true"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Last Name
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.Last" class="t-field-text w100" (change)="idchanged=true"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <div class="w33">
                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                          Gender 
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <select class="t-select w100" style="padding-left: 5%;" [(ngModel)]="myPat.Sex" (ngModelChange)="onSexChange()" >
                                <option value="">Select</option>
                                <option value="F">Female</option>
                                <option value="M">Male</option>
                                <option value="O">Other</option>

                            </select>
                        </span>
                        
                    </div>
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            First Name Eng.
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.FirstEng" class="t-field-text w100" (change)="idchanged=true"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Last Name Eng.
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.LastEng" class="t-field-text w100" (change)="idchanged=true"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->
                

                

                <!-- cell ( start ) -->
                <div class="w33" [ngClass]="myPat.Height && myPat.Weight? 'smallbox':''" (change)="myPat.BSAus=null">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Height
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <span class="t-field t-field--number">
                                <input [(ngModel)]="myPat.Height" class="t-field-text" type="number" min="0">
                                <span class="t-field-desc">
                                    cm
                                </span>
                            </span>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->					

                <!-- cell ( start ) -->
                <div class="w33" [ngClass]="myPat.Height && myPat.Weight? 'smallbox':''">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Weight
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <span class="t-field t-field--number">
                                <input [(ngModel)]="myPat.Weight" class="t-field-text" type="number" min="0" (change)="myPat.BSAus=null">
                                <span class="t-field-desc">
                                    kg
                                </span>
                            </span>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->
                
                <div class="w33 smallbox" *ngIf="myPat.Weight && myPat.Height">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            BMI
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <span class="t-field t-field--number">
                                {{getBMI()}}
                            </span>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <div class="w33 smallbox" *ngIf="ls.isCardio && myPat.Weight && myPat.Height">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label [matTooltip]="myPat.BSAus ? 'From Ultrasound': 'Calculated'" [ngClass]="myPat.BSAus ? 'red':''">
                            BSA
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <span class="t-field t-field--number">
                                {{getBSA()}}
                            </span>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                    <!-- cell ( start ) -->
                <div class="w33">

                        <div class="l-flex l-flex-c t-field t-field-pad">

                            <label>
                                Birth Date
                            </label>

                            <i class="t-sep"></i>

                            <span class="t-validation-wrap l-fg1">
                                <input [(ngModel)]="Birth"  (dateChange)="dateChanged('Birth')"  [matDatepicker]="birthpicker" [max]="maxBD"  class="t-field-text w100"/>
                                <img src="../../assets/icons/date.svg" (click)="birthpicker.open()" style='position:absolute'>
                                <mat-datepicker #birthpicker [startAt]="startBD" startView="year"></mat-datepicker>
                            </span>
                            
                        </div>
                        
                    </div>
                    <!-- cell ( end ) -->
                

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Email
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="email" [(ngModel)]="myPat.Email" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Mobile
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="tel" [(ngModel)]="myPat.Mobile" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Phone
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="tel" [(ngModel)]="myPat.Phone" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Address
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.Address" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Town
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.City" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Zip Code
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <input type="text" [(ngModel)]="myPat.Zip" class="t-field-text w100"/>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Blood Type
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <select class="t-select w100" style='text-align: center;'[(ngModel)]="myPat.BloodType">
                                <option value="">Select</option>
                                <option value="A+">A+</option>
                                <option value="B+">B+</option>
                                <option value="AB+">AB+</option>
                                <option value="O+">O+</option>
                                <option value="A-">A-</option>
                                <option value="B-">B-</option>
                                <option value="AB-">AB-</option>
                                <option value="O-">O-</option>
                            </select>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

                <!-- cell ( start ) -->
                <div class="w33">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Health Provider
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <select class="t-select w100" [(ngModel)]="myPat.HMO" (change)="idchanged=true">
                                <option value="">Select</option>
                                <option value="Clalit">Clalit</option>
                                <option value="Macabi">Macabi</option>
                                <option value="Meuhedet">Meuhedet</option>
                                <option value="Leumit">Leumit</option>
                                <option value="Private">Private</option>
                                <option *ngIf="ls.isCardio || !ls.ishospital" value="IDF">IDF</option>

                            </select>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

               
                

                <!-- cell ( start ) -->
                <div class="w33" *ngIf="myPat.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                        <img src="../../assets/icons/drb.svg">
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            {{ls.getDocByUID(myPat.UID)}}
                        </span>
                        
                    </div>
                    
                </div>
                <div class="w33" *ngIf="ls.isObgyn && myPat.Sex !='M'">

                    <div class="l-flex l-flex-c t-field t-field-pad">							
                        <span class="t-validation-wrap l-fg1 w65" style="display: flex;">
                            <label>
                                LMP:
                            </label>
                            <input [(ngModel)]="myPat.LMP" (dateChange)="dateChanged(myPat.LMP);checklmp();this.lmpGA(myPat.LMP)" [matDatepicker]="lmppicker" [max]="maxLMP"  [min]="minLMP" class="t-field-text w100" [ngClass]="invalidlmp"/>
                            <mat-datepicker #lmppicker ></mat-datepicker>
                            <div class="t-validation-message">
                                <span>Invalid LMP</span>
                            </div>
                            <img src="../../assets/icons/date.svg" (click)="lmppicker.open()" style='margin-left: -1.8em;'>

                        </span>
                        <i class="t-sep"></i>
                   
                        <span class="t-validation-wrap l-fg1 w35" style="display: flex;">
                            <label>
                                GA:
                            </label>
                            <span style="font-weight: bolder;">{{lmpGA(myPat.LMP)}}</span>
                        </span> 
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->
                <!-- <div class="w33" *ngIf="! tryCopy && myPat.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')">
                    
                    <div class="l-flex l-flex-c t-field t-field-pad">
                        <button class="search-btn" style="max-width: 3.5em" [disabled]="copyTo? false: 'disabled'" (click)="copyPat()">
                            Copy
                        </button>
                        to
                        <select [(ngModel)]="copyTo" class="t-select w100" style="text-align: center;" (change)="idchanged=true">
                            <ng-container *ngFor="let e of ls.clinicUsers">
                                <option [value]="e.UID" *ngIf="e.UID != myPat.UID">{{e.Name}}</option>
                            </ng-container>
                        </select>
                        
                    </div>
                    
                </div> -->
                <!-- <div class="w33" *ngIf="copyNote">
                    {{copyNote}} -->
                <!-- </div> -->
              
              
                <!-- cell ( start ) -->
                <div class="w100">

                    <div class="l-flex l-flex-c t-field t-field-pad">

                        <label>
                            Comments
                        </label>

                        <span class="t-validation-wrap is-sep l-fg1">
                            <textarea [(ngModel)]="myPat.Comments" class="t-field-text w100"></textarea>
                        </span>
                        
                    </div>
                    
                </div>
                <!-- cell ( end ) -->

            </div>

            <div class="buttons-container">
            <button class="save_patieont" (click)="savePatient();"   matTooltip="שמור פרטי נבדק/ת" *ngIf="! hideSave && ! ls.barcodeScan">
                Confirm
            </button>
           
        </div>
            
         

            

            
            
        </div>
    </div>

</div>


